import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1 text-foreground-600">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <i className="ri-arrow-right-s-line text-secondary-400"></i>}
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600">{item.label}</Link>
            ) : (
              <span className="text-foreground-900">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}